import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "@/config/authConfig";
import { Loader } from "@components/Loader";
import { useEffect } from "react";

export const Invite = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      window.location.replace("/");
      return;
    }
    if (inProgress !== InteractionStatus.None) return;
    const email = new URLSearchParams(window.location.search).get("email") ?? "";
    instance.loginRedirect({
      ...loginRequest,
      prompt: "login",
      ...(email && { loginHint: email }),
    });
  }, [inProgress, instance, isAuthenticated]);

  return <Loader className="content" show={true} />;
};
